module.exports = __webpack_public_path__ + "img/Health.1784196c.svg";